import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';

const ImageViewerPanel: React.FC = () => {
  const images = useSelector((state: RootState) => state.dashboard.images);
  const API_URL = import.meta.env.VITE_API_URL || window.location.origin;
  const token = localStorage.getItem('auth_token');
  const [selectedIndex, setSelectedIndex] = useState(-1);

  const imageUrls = useMemo(() => {
    return images.map(img => {
      if (img.image) return img.image;
      if (img.sessionId && img.filename && token) {
        return `${API_URL}/api/dashboard/images/${img.sessionId}/${img.filename}?token=${token}`;
      }
      if (img.id && token) {
        return `${API_URL}/api/dashboard/images/by-id/${img.id}?token=${token}`;
      }
      return null;
    }).filter(Boolean) as string[];
  }, [images, token]);

  const latestUrl = imageUrls.length > 0 ? imageUrls[imageUrls.length - 1] : null;
  const displayUrl = selectedIndex >= 0 && selectedIndex < imageUrls.length ? imageUrls[selectedIndex] : latestUrl;

  return (
    <div className="bg-white dark:bg-claude-darkSurface rounded-xl shadow-sm border border-gray-200 dark:border-claude-darkBorder">
      <div className="px-4 py-3 border-b border-gray-200 dark:border-claude-darkBorder">
        <div className="flex items-center gap-2">
          <svg className="w-4 h-4 text-indigo-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
          <h3 className="text-sm font-medium text-gray-900 dark:text-claude-darkText">Images</h3>
          <span className="ml-auto text-xs text-gray-400">{images.length} captured</span>
        </div>
      </div>
      <div className="p-4">
        {displayUrl ? (
          <div className="space-y-3">
            <div className="relative bg-black rounded-lg overflow-hidden" style={{ aspectRatio: '16/9' }}>
              <img src={displayUrl} alt="Captured" className="w-full h-full object-contain" />
            </div>
            {imageUrls.length > 1 && (
              <div className="flex gap-2 overflow-x-auto pb-1">
                {imageUrls.map((url, i) => (
                  <button
                    key={i}
                    onClick={() => setSelectedIndex(i === selectedIndex ? -1 : i)}
                    className={`shrink-0 w-14 h-10 rounded border-2 overflow-hidden transition-colors ${
                      (i === selectedIndex || (selectedIndex < 0 && i === imageUrls.length - 1))
                        ? 'border-blue-500'
                        : 'border-transparent hover:border-gray-400'
                    }`}
                  >
                    <img src={url} alt={`thumb-${i}`} className="w-full h-full object-cover" />
                  </button>
                ))}
              </div>
            )}
          </div>
        ) : (
          <div className="flex items-center justify-center h-32 text-gray-400 dark:text-claude-darkTextSecondary text-sm">
            No images captured
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageViewerPanel;